import * as React from 'react';
import { ClipbookInfo } from 'ark-common';

interface StartDialogProps {
  visible: boolean;
  existingClipbooks: ReadonlyArray<ClipbookInfo>;
  onNewClipbook: () => void;
  onOpenClipbook: (id: string) => void;
}

export default class StartDialog extends React.PureComponent<StartDialogProps> {
  private createListItems() {
    const items: JSX.Element[] = [];

    const sortedClipbooks = this.props.existingClipbooks.slice();
    sortedClipbooks.sort((a, b) => b.lastModified - a.lastModified);

    for (const item of sortedClipbooks) {
      items.push(
        <li key={item.id} className="mdc-list-item"
          onClick={() => this.props.onOpenClipbook(item.id)}>
          {item.title} - {new Date(item.lastModified).toString()}
        </li>,
      );
    }

    return items;
  }

  public render() {
    const dialogStyle: React.CSSProperties = {
      visibility: this.props.visible ? 'visible' : 'hidden',
    };

    const headingStyle = {
      margin: '0',
    };

    return (
      <div className="mdc-dialog mdc-dialog--open" style={dialogStyle}>
        <div className="mdc-dialog__surface">
          <header className="mdc-dialog__header">
            <h1 style={headingStyle}>バインダーの選択</h1>
          </header>
          <section className="mdc-dialog__body mdc-dialog__body--scrollable">
            <ul className="mdc-list">
              {this.createListItems()}
            </ul>
          </section>
          <footer className="mdc-dialog__footer">
            <button type="button"
              className="mdc-button mdc-dialog__footer__button"
              onClick={this.props.onNewClipbook}>
              新規作成
            </button>
          </footer>
        </div>
        <div className="mdc-dialog__backdrop"></div>
      </div>
    );
  }
}
